"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var sap_const_1 = require("./sap.const");
/**
 * SapService
 * @class
 */
var SapService = /** @class */ (function () {
    function SapService() {
    }
    /**
     * Download sap file
     * @param data {SapRequest}
     * @returns {Promise<any>}
     */
    SapService.prototype.exportSAP = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var headers = {
            'Content-Type': 'application/zip',
            'Content-Disposition': 'attachment; filename="sap.zip"',
        };
        var query = this.getQuery(data);
        var url = sap_const_1.SAP_ENDPOINT.exportSAP
            .replace('{{version}}', version)
            .replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.request({
            url: url,
            headers: headers,
            responseType: 'arraybuffer',
        });
    };
    /**
     * Create query for urls
     * @param params {any}
     * @returns String
     */
    SapService.prototype.getQuery = function (params) {
        if (!lodash_1.isNil(params) && !lodash_1.isEmpty(params)) {
            var query_1 = '?';
            var keys_1 = lodash_1.keys(params);
            keys_1.forEach(function (key, i) {
                query_1 += key + "=" + params[key];
                if (keys_1.length - 1 > i) {
                    query_1 += '&';
                }
            });
            return query_1;
        }
        return '';
    };
    return SapService;
}());
/**
 * SapService Class Instance
 * @namespace
 */
exports.sap = new SapService();
